module.exports = __webpack_public_path__ + "img/product-09.7c708692.jpg";